import Vue from 'vue';
import { ResourceType } from '@/types/base';
var resourceType = ResourceType;
var constants = {
    appName: process.env.appName,
    resourceType: resourceType
};
export default Vue.prototype.$constants = constants;
